import React, { useState } from "react";
import "./../css/OrderDetail.css";

const EditOrderModal = ({
                            order,
                            onClose,
                            onSave,
                            existingItems = [],
                            showToast
                        }) => {

    const [items, setItems] = useState(existingItems);
    const [deliveryCharge, setDeliveryCharge] = useState(order?.delivery_charge || 0);

    const [deletedIds, setDeletedIds] = useState([]);

    const handleChange = (index, field, value) => {
        const updated = [...items];
        updated[index][field] = field === "name" ? value : Number(value);

        if (field === "quantity" || field === "price") {
            updated[index].subtotal = updated[index].quantity * updated[index].price;
        }

        setItems(updated);
    };

    const isExistingItem = (id) => {
        return existingItems.some((item) => item.id === id);
    };

    const addItem = () =>
        setItems([
            ...items,
            { name: "", quantity: 1, price: 0, subtotal: 0 }
        ]);


    const removeItem = (index) => {
        const item = items[index];

        if (item?.id) {
            setDeletedIds((prev) => [...prev, item.id]);
        }

        setItems(items.filter((_, i) => i !== index));
    };

    const isValidItem = (item) =>
        item.name?.trim() !== "" &&
        Number(item.quantity) > 0 &&
        Number(item.price) > 0;

    const hasChanges = () => {
        if (Number(deliveryCharge) !== Number(order?.delivery_charge)) {
            return true;
        }

        const validItems = items.filter(isValidItem);
        const validExisting = existingItems.filter(isValidItem);

        if (validItems.length !== validExisting.length) {
            return true;
        }

        for (let i = 0; i < validItems.length; i++) {
            const curr = validItems[i];
            const prev = validExisting[i];

            if (!prev) return true;

            if (
                curr.name !== prev.name ||
                Number(curr.quantity) !== Number(prev.quantity) ||
                Number(curr.price) !== Number(prev.price)
            ) {
                return true;
            }
        }

        return false;
    };


    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-box om-box" onClick={(e) => e.stopPropagation()}>

                <div className="modal-header">
                    <div>
                        <h3 className="modal-title" style={{ marginBottom: 2 }}>
                            Manage Order
                        </h3>
                        <span className="card-header__id">
                            #{order?.unique_order_id}
                        </span>
                    </div>
                    <button className="modal-close" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body om-body">

                    <div className="om-meta-row">
                        <div>
                            <div className="label">Restaurant</div>
                            <div className="value om-restaurant">
                                {order?.restaurant?.name}
                            </div>
                        </div>

                        <div className="om-delivery-wrap">
                            <div className="label om-delivery-label">
                                Delivery Charge
                            </div>
                            <input
                                type="number"
                                value={deliveryCharge}
                                onChange={(e) => setDeliveryCharge(e.target.value)}
                                className="om-input om-input--mono om-input--delivery"
                                onFocus={focusStyle}
                                onBlur={blurStyle}
                            />
                        </div>
                    </div>

                    <div className="divider divider--sm" />

                    <div className="om-table-header">
                        {["Item Name", "Qty", "Price", "Subtotal", ""].map((h, i) => (
                            <div key={i} className="label">{h}</div>
                        ))}
                    </div>

                    <div className="om-items">
                        {items.map((item, index) => {
                            const isDisabled = isExistingItem(item.id);

                            return (
                                <div className="om-row-inner" key={index}>
                                    <input
                                        disabled={isDisabled}
                                        placeholder="Item name…"
                                        value={item.name}
                                        onChange={(e) =>
                                            handleChange(index, "name", e.target.value)
                                        }
                                        className="om-input om-input--name"
                                        onFocus={focusStyle}
                                        onBlur={blurStyle}
                                    />

                                    <div className="om-field">
                                        <span className="om-field-label">Qty</span>
                                        <input
                                            disabled={isDisabled}
                                            type="number"
                                            value={item.quantity}
                                            onChange={(e) =>
                                                handleChange(index, "quantity", e.target.value)
                                            }
                                            className="om-input om-input--mono"
                                            onFocus={focusStyle}
                                            onBlur={blurStyle}
                                        />
                                    </div>

                                    <div className="om-field">
                                        <span className="om-field-label">Price</span>
                                        <input
                                            disabled={isDisabled}
                                            type="number"
                                            value={item.price}
                                            onChange={(e) =>
                                                handleChange(index, "price", e.target.value)
                                            }
                                            className="om-input om-input--mono"
                                            onFocus={focusStyle}
                                            onBlur={blurStyle}
                                        />
                                    </div>

                                    <div className="om-field">
                                        <span className="om-field-label">Subtotal</span>
                                        <div className="om-subtotal">
                                            ₹{(item.quantity * item.price || 0).toFixed(2)}
                                        </div>
                                    </div>

                                    <button
                                        className="om-delete"
                                        onClick={() => removeItem(index)}
                                    >
                                        ✕
                                    </button>
                                </div>
                            );
                        })}
                    </div>

                    <button onClick={addItem} className="btn om-add-btn">
                        + Add Item
                    </button>
                </div>

                <div className="modal-footer">
                    <button className="btn" onClick={onClose}>Cancel</button>

                    <button
                        disabled={!hasChanges()}
                        style={{
                            opacity: !hasChanges() ? 0.5 : 1,
                            cursor: !hasChanges() ? "not-allowed" : "pointer"
                        }}
                        className="action-btn om-save-btn"
                        onClick={() => {
                            const existingIdsToDelete = existingItems
                                .filter((oldItem) => !items.some((i) => i.id === oldItem.id))
                                .map((item) => item.id);


                            const newItems = items.filter(
                                (item) =>
                                    !item.id && // new items only
                                    item.name?.trim() !== "" && // must have name
                                    Number(item.quantity) > 0 &&
                                    Number(item.price) > 0
                            );

                            const remainingExistingItems =
                                existingItems.length - existingIdsToDelete.length;

                            if (remainingExistingItems === 0 && newItems.length === 0) {
                                showToast("error", "Order must have at least one item");
                                return;
                            }


                            const payload = {
                                delivery_charge: Number(deliveryCharge) || 0,
                                item_ids: deletedIds.join(",") || null,
                                name: newItems.map((i) => i.name),
                                quantity: newItems.map((i) => i.quantity),
                                price: newItems.map((i) => i.price),
                            };

                            onSave?.(payload);
                        }}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

const focusStyle = (e) => {
    e.target.style.borderColor = "#6366f1";
    e.target.style.boxShadow = "0 0 0 3px rgba(99,102,241,0.08)";
};

const blurStyle = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
};

export default EditOrderModal;